<template>
  <div class="animated fadeIn" v-if="this.$can('device','index')">
    <b-row>
      <b-col class="mb-12" cols="12">
        <b-card 
          header="Devices"  
          header-bg-variant="primary"
          header-text-variant="white" 
          class="table-responsive">
          <devices-filter-bar></devices-filter-bar>
          <vuetable ref="vuetable"
              :row-class="onRowClass"
              api-url="api/devices"
              :http-options="httpOptions"
              :fields="fields"
              pagination-path=""
              :css="css.table"
              :sort-order="sortOrder"
              :multi-sort="true"
              :append-params="moreParams"
              :per-page="15"
              :options="options"
              detail-row-component="devices-detail-row"
              @vuetable:cell-clicked="onCellClicked"
              @vuetable:pagination-data="onPaginationData"
          ></vuetable>
          <div class="vuetable-pagination">
              <vuetable-pagination-info 
                  ref="paginationInfo"
                  info-class="pagination-info" 
                  info-template="{from} to {to} of {total} devices">
              </vuetable-pagination-info>
              <vuetable-pagination ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
          </div>
        </b-card>
      </b-col>
     </b-row>


</div>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
import moment from 'moment'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
// import VuetablePagination from 'vuetable-2/src/components/VuetablePaginationDropdown'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import DevicesDetailRow from './DevicesDetailRow'
import DevicesFilterBar from './DevicesFilterBar'
import DevicesActions from './DevicesActions'

Vue.use(VueEvents)
Vue.component('devices-actions', DevicesActions)
Vue.component('devices-detail-row', DevicesDetailRow)

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    DevicesFilterBar,    
  },  
  data () {
    return {
      options: {
          perPageValues: [10,25,50,100], // TODO:
          perPage:100,

      },
      httpOptions: { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } },
      fields: [
        // {
        //   name: '__checkbox',   // <----
        //   titleClass: 'center aligned',
        //   dataClass: 'center aligned',

        // },
        {
          name: '__sequence',   // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: '__component:devices-actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        },

        {
          name: 'name',
          sortField: 'name',
          title: "Device Name",
        },
        {
          name: 'mac',
          sortField: 'mac',
          title: "WAN MAC",
          // visible: false,
        },
        {
          name: 'serial',
          sortField: 'serial',
          title: 'Serial #',
        },
        {
          name: 'account.name',
          sortField: 'account_id',
          title: 'Account',
        },
        {
          name: 'product.name',
          sortField: 'product_id',
          title: 'Model',
        },
          {
          name: 'fw_version',
          sortField: 'fw_version',
          title: 'Version',
        },
        {
          name: 'recent_checkin',
          sortField: 'recent_checkin',
          title: 'Check in',
          callback: 'relativeTime'
        },        
        // {
        //   name: '__component:devices-actions',
        //   title: 'Actions',
        //   titleClass: 'text-center',
        //   dataClass: 'text-center'
        // }
      ],
      css: {
          table: {
            tableClass: 'table table-bordered table-striped table-sm ',
            loadingClass: 'loading',
            ascendingIcon: 'fa fa-chevron-up',
            descendingIcon: 'fa fa-chevron-down',
            detailRowClass: 'vuetable-detail-row',
            handleIcon: 'fa fa-shower',
          },
          pagination:{
            wrapperClass: "pagination pull-right",
            activeClass: "btn-primary",
            disabledClass: "disabled",
            pageClass: "btn btn-border",
            linkClass: "btn btn-border",
            icons: {
                first: "",
                prev: "",
                next: "",
                last: ""
            },
          },
      },
      sortOrder: [

        { field: 'recent_checkin', sortField: 'recent_checkin', direction: 'desc'}
      ],
      moreParams: {}
    }
  },
  methods: {
    
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD').format(fmt)
    },
    onRowClass (dataItem, index) {
    return (dataItem.presence)? 'row-online': 'row-offline'
    },
    relativeTime (value){
      let localTime = moment.utc(value).local();
        return (value == null) ? '-' : moment(localTime).fromNow()
    },
    // myNumFormat($value){
    //     return (value == null) ? '' : Intl.NumberFormat().format($value)
    // },
    evaluarNacionalidad(value){
        return value;
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onCellClicked (data, field, event) {
      console.log('cellClicked: ', field.name)
      this.$refs.vuetable.toggleDetailRow(data.id)
    },       
  }, 
  events: {
    'filter-set' (filterText) {
//      this.moreParams = {
//        filter: filterText
//      }
this.moreParams["filter"] = filterText;
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
        'account-set'(selected_acct) {
            this.moreParams["account_id"] = selected_acct;

            Vue.nextTick(() => this.$refs.vuetable.refresh())
        },
    'filter-reset' () {
      this.moreParams = {}
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'refreshTable'(){
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
      console.log('Table Refreshed: 934749')
    },   
  }

}
</script>
<style>

.row-online {
  background-color: #b2dced   !important;
}

.row-offline {
  background-color: #F0FFFF   !important;
}
  .pagination {
    margin: 0;
    float: right;
  }
  .pagination a.page {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 10px;
    margin-right: 2px;
  }
  .pagination a.page.active {
    color: white;
    background-color: #337ab7;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 10px;
    margin-right: 2px;
  }
  .pagination a.btn-nav {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 7px;
    margin-right: 2px;
  }
  .pagination a.btn-nav.disabled {
    color: lightgray;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 5px 7px;
    margin-right: 2px;
    cursor: not-allowed;
  }
  .pagination-info {
    float: left;
  }
table.vuetable {
     table-layout: auto;
}
.vuetable-body > tr > td {
     white-space: nowrap;
     overflow: hidden; 
     text-overflow: ellipsis; 
}
.vuetable th#_id {
     width: 80px;
}
.vuetable th#_action {
     width: 70px;
}

.router-link-exact-active.router-link-active.nav-link {
    font-weight: bold;
    text-transform: uppercase;
    background-color: #20a8d8;
}
.navbar-nav .nav-link {
    color: #000;
}



</style>
